<template>
  <div class="main_center" style="margin: 0 0;padding-top: 8px;">

    <div class="content">

      <el-form ref="form" :model="form" label-width="115px">
        <el-row>
          <el-col :span="6" >
            <el-form-item label="接口类型：" prop='interType'>
              <el-select v-model="form.interType" clearable @change="seachBtn()">
                <el-option v-for="(item,index) in interTypeNameList" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="文件获取方式：" prop='fileDownMod'>
              <el-select v-model="form.fileDownMod" clearable @change="seachBtn()">
                <el-option v-for="(item,index) in fileDownModNamelist" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item >
              <el-input v-model="form.search" clearable placeholder="请输入关键字搜索" @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <div style="float:right;">
            <!--            <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true"
                                   icon="el-icon-arrow-down">展开
                        </el-button>
                        <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false"
                                   icon="el-icon-arrow-up">收起
                        </el-button>-->
            <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
            <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
          </div>
        </el-row>
      </el-form>
      <div style="position: relative;top:-10px">
        <el-button size="small"  icon="el-icon-plus" type="primary"
                   v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_add')"
                   @click="routerAdd">新增</el-button>
        <el-button size="small" icon="el-icon-delete" type="primary"
                   v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_delete')"
                   @click="deleteSelectItem()">删除
        </el-button>
      </div>

      <el-table :data="tableData"
                ref="multipleTable"
                v-loading="dataListLoading"
                :height="tableMaxHeight"
                stripe border
                @selection-change="handleSelectionChange">
        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_delete')" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="查看"
                       v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_view')"
                       @click="router(scope.row)">查看</el-button>
            <el-button type="text" title="删除"
                       v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_delete')"
                       @click="deleteById(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>


        <el-table-column label="系统名称" prop='systemName' header-align="center" align="left" min-width='100'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="所属单位" prop='orgName' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="接口类型" prop='interTypeName' header-align="center" align="center" width='100'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag v-if="scope.row.interType" :type="formatterTagType(scope.row.interType,'interType')" size="small" :hit="false" effect="plain"  > {{scope.row.interTypeName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="所属交易中心" prop='tradeId' header-align="center" align="center" width='200'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag type="success" size="small" :hit="false" effect="plain"  > {{convertTrade(scope.row.tradeId)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="关联应用" prop='appId' header-align="center" align="center" min-width='90'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag type="success" size="small" :hit="false" effect="plain"  > {{convertApp(scope.row.appId)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="文件获取方式" prop='fileDownModName' header-align="center" align="center" width='130'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag v-if="scope.row.fileDownMod" :type="formatterTagType(scope.row.fileDownMod,'fileDownMod')" size="small" :hit="false" effect="plain"  > {{scope.row.fileDownModName}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination background
                     layout="sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination> -->
                     <pagination
                                class="limit"
                                :page-sizes="[10, 20, 50, 100]"
                                :total="total"
                                :page.sync="pageIndex"
                                :limit.sync="pageSize"
                                @pagination="paginationChange">
                        </pagination>  
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Pagination from '@/components/Pagination.vue';
 export default {
    components:{Pagination},
   props: ['mainContentViewHeight'],
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 267,
      dataListLoading: false,
      form: {
        search:'' ,//搜索框的值
        interType:'',
        fileDownMod:'',
      },
      tradeList:[],
      appList:[],
      interTypeNameList:[],
      fileDownModNamelist:[],
      moreSearchItem: false,
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {}
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user,
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  created() {
    this.getDic('jz_interface_type')
    this.getDic('jz_third_filedownmod')
    this.tradeList = sessionStorage.getItem("transactionCenterList") && JSON.parse(sessionStorage.getItem("transactionCenterList")) || [];
    this.appList = sessionStorage.getItem("appList") &&  JSON.parse(sessionStorage.getItem("appList")) || [];
  },
  activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    // this.reflash();
    this.getDataList()
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
      let hasBtnPermisson = this.hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_delete') || this.hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_add');
      let tableMaxHeight = document.documentElement.clientHeight - 320 + (hasBtnPermisson ? 0 : 33);
      console.log('this.mainContentViewHeight=>',this.mainContentViewHeight)
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      //this.getDataList()
    },

    convertTrade(tradeId){
      var items=this.tradeList.filter(f=>f.id==tradeId);
      return items&&items.length>0?items[0].orgName:"";
    },
    convertApp(appid){
      var items=this.appList.filter(f=>f.id===appid);
      return items&&items.length>0?items[0].appName:"未关联应用";
    },
    getDic(type){ // 获取字典
      this.$http.get('/sys/dictData/getList?type='+type).then(res=>{
        if(res.data.code==='1'){
          switch(type){
            case 'jz_interface_type':this.interTypeNameList =res.data.data;break;
            case 'jz_third_filedownmod':this.fileDownModNamelist =res.data.data;break;
          }
        }
      })
    },

    getDataList() { // 获取列表数据
      this.dataListLoading=true;
      this.$http.post('/thirdsConfig/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': this.form.search,
        'filter': this.form
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading=false;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seachBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    reflash() {//刷新按钮
      this.pageIndex = 1;
      this.$refs['form'].resetFields();

      this.form.search = "";
      this.form.fileDownMod="";
      this.form.interType="";

      this.getDataList()

    },

    routerAdd(){ //新增
      window.sessionStorage.setItem("addUpdateIndex",2);

      window.sessionStorage.setItem("id", '');

      this.$router.push({
        name:'thirds_config_detail'
      })

    },

    router(item){ // 跳转详情
      var id = item.id;
      window.sessionStorage.setItem("id", id);
      window.sessionStorage.setItem("addUpdateIndex",1)

      this.$router.push({
        name:'thirds_config_view'
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/thirdsConfig/delete', {
          id: item.id
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$http.post('/thirdsConfig/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },

    paginationChange(obj){
                this.pageIndex= obj.page||1
                this.pageSize=obj.limit||10
                this.getDataList();
            },

  }


}
</script>

<style lang="less">
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>